import { useEffect, useRef } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export default function VerifyMagicLink({ csrfToken }) {
  const formRef = useRef(null)

  useEffect(() => {
    formRef.current?.submit()
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Signing you in...</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-primary" />
          </div>
          <form ref={formRef} action="/auth/verify" method="post">
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <p className="text-sm text-muted-foreground mb-3">
              Not redirected automatically?
            </p>
            <Button type="submit" variant="outline" size="sm">
              Click here to sign in
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
